import React from 'react';
import './Navigation.css';

function Navigation() {
  const navigate = (path) => {
    const event = new CustomEvent('navigate', { detail: path });
    window.dispatchEvent(event);
  };

  return (
    <nav className="main-nav">
      <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="nav-logo">
        Retrorocket Labs
      </a>
      <div className="nav-links">
        <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="nav-link">Home</a>
        <a href="/about" onClick={(e) => { e.preventDefault(); navigate('/about'); }} className="nav-link">About</a>
        <a href="/products" onClick={(e) => { e.preventDefault(); navigate('/products'); }} className="nav-link">Products</a>
      </div>
    </nav>
  );
}

export default Navigation;
